import React from 'react';
import {AppBar, 
        Toolbar,
        Typography,
        IconButton,
} from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import {useSelector} from "react-redux";
import {State} from "../reducer";
import {ExitToApp} from "@mui/icons-material";
import {logout} from "../keycloak";
import HeaderMenu from "./HeaderMenu";
import { useAppDispatch } from '../store';
import styled from '@emotion/styled';

const Header = () => {
    const auth = useSelector(({auth}: State) => auth);
    const dispatch = useAppDispatch();

    const LogoImageStyle = styled('img')`
    height: 40px;
    padding-left: 10px;
`;

    const PartnerTypography = styled(Typography)({
        flexGrow: 1,
            fontSize: 12,
            color: 'lightgrey',
        });

    return (
        <div style={{flexGrow: 1}}>
            <AppBar position="static">
                <Toolbar>
                    <HeaderMenu/>
                    <Typography variant="h6" sx={{flexGrow: 1, textAlign: 'center'}}>
                        <img style={{cursor: 'default', height:50, filter: 'invert(100%)'}} alt="" src="https://upload.wikimedia.org/wikipedia/fr/thumb/f/f7/Logo_Hachette_Livre_Actuel.svg/1280px-Logo_Hachette_Livre_Actuel.svg.png"/>
                    </Typography>
                    <PartnerTypography variant="h6">
                    <div onClick={() => window.location.href = 'mailto:cyclade@hachette-livre.fr'}>
                        <label>Données issues du référentiel Hachette Livre</label>
                        <LogoImageStyle alt="" src="/images/logo_cyclade.png"/>
                    </div>
                    </PartnerTypography>
                    <PartnerTypography variant="h6"> 
                    <div onClick={() => window.location.href = 'mailto:scoutifyteam@hachette-livre.fr'}>
                        <label>Données des e-librairies fournies par l'équipe Scoutify</label>
                        <LogoImageStyle alt="" src="/images/logo_scoutify.png"/>
                    </div>

                    </PartnerTypography>
                    {auth.authenticated && (
                        <div>
                            <IconButton
                                color="inherit">
                                <AccountCircle/> <label className="header-label">{auth?.user?.firstname}</label>
                            </IconButton>
                            <IconButton
                                onClick={() => dispatch(logout())}
                                color="inherit"
                            >
                                <ExitToApp/>
                                <label className="header-label">Déconnexion</label>
                            </IconButton>
                        </div>
                    )}
                </Toolbar>
            </AppBar>
        </div>
    );
}
export default Header;